module.exports = __webpack_public_path__ + "static/media/Donate.aaed55c1.png";